module.exports = ".btn-marron {\r\n    margin-right: 25px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard/message/message.component.css
// module id = ./src/app/modules/dashboard/dashboard/message/message.component.css
// module chunks = dashboard.module